import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import UnvDrawer from 'components/UnvDialog/UnvDrawer'
import HistoryViewer from 'components/HistoryViewer/HistoryViewer'
import {
  Skeleton,
  EmptyState,
  ErrorState,
  DataTable,
  UnvInput,
} from 'components'
import $apiJSON from 'http/apiJSON'
import styles from '../AdminFullPage.module.scss'

function EmployeesTab() {
  const { t } = useTranslation('common')
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadError, setLoadError] = useState(false)
  const [q, setQ] = useState('')
  const [drawer, setDrawer] = useState(null)
  const [drawerTab, setDrawerTab] = useState('main')

  const load = () => {
    setLoading(true)
    setLoadError(false)
    $apiJSON
      .get('/employees/all-employees/', { params: { user_type: 'E' } })
      .then((res) => {
        const data = res?.data || res
        setItems(Array.isArray(data) ? data : data?.results || [])
      })
      .catch(() => {
        setLoadError(true)
        setItems([])
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    load()
  }, [])

  const filtered = items.filter((e) => {
    if (!q) return true
    const term = q.toLowerCase()
    const haystack = [e.first_name, e.last_name, e.surname, e.email, e.inn]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()
    return haystack.includes(term)
  })

  return (
    <div>
      <h2 className={styles.section_title}>{t('admin.fullPage.employees_title')}</h2>

      <div className={styles.toolbar}>
        <UnvInput
          iconLeft="search"
          placeholder={t('common.search')}
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      {loading ? (
        <Skeleton variant="table" rows={8} cols={5} />
      ) : loadError ? (
        <ErrorState title={t('admin.fullPage.employees_not_found')} onRetry={load} />
      ) : filtered.length === 0 ? (
        <EmptyState iconName="users" title={t('admin.fullPage.employees_not_found')} />
      ) : (
        <DataTable
          columns={[
            { key: 'id', label: 'ID', sortable: true, width: 80 },
            {
              key: 'full_name',
              label: t('common.fullName'),
              sortable: true,
              render: (_, e) => [e.surname, e.first_name, e.last_name].filter(Boolean).join(' '),
            },
            { key: 'email', label: 'Email', render: (v) => v || '—' },
            { key: 'position', label: t('admin.fullPage.employees_th_position'), render: (_, e) => e.position?.title || e.position || '—' },
            { key: 'division', label: t('admin.fullPage.employees_th_division'), render: (_, e) => e.division?.title || e.division || '—' },
          ]}
          data={filtered}
          searchable={false}
          pageSize={20}
          onRowClick={(row) => {
            setDrawerTab('main')
            setDrawer(row)
          }}
          emptyText={t('admin.fullPage.employees_not_found')}
        />
      )}

      <UnvDrawer
        open={!!drawer}
        title={
          drawer
            ? [drawer.surname, drawer.first_name, drawer.last_name]
                .filter(Boolean)
                .join(' ')
            : ''
        }
        onClose={() => setDrawer(null)}
      >
        {drawer ? (
          <div>
            <div className="unv-tabs">
              <button
                type="button"
                className={`unv-tab ${drawerTab === 'main' ? 'unv-tab--active' : ''}`}
                onClick={() => setDrawerTab('main')}
              >
                {t('admin.fullPage.drawer_tab_main')}
              </button>
              <button
                type="button"
                className={`unv-tab ${drawerTab === 'history' ? 'unv-tab--active' : ''}`}
                onClick={() => setDrawerTab('history')}
              >
                {t('admin.fullPage.drawer_tab_history')}
              </button>
            </div>
            {drawerTab === 'main' ? (
              <div className={styles.kv}>
                <div className={styles.kv_key}>ID</div>
                <div>{drawer.id}</div>
                <div className={styles.kv_key}>{t('admin.fullPage.kv_inn')}</div>
                <div>{drawer.inn || '—'}</div>
                <div className={styles.kv_key}>Email</div>
                <div>{drawer.email || '—'}</div>
                <div className={styles.kv_key}>{t('common.phone')}</div>
                <div>{drawer.number_phone || drawer.phone || '—'}</div>
                <div className={styles.kv_key}>{t('admin.fullPage.employees_th_position')}</div>
                <div>{drawer.position?.title || drawer.position || '—'}</div>
                <div className={styles.kv_key}>{t('admin.fullPage.employees_th_division')}</div>
                <div>{drawer.division?.title || drawer.division || '—'}</div>
              </div>
            ) : (
              <HistoryViewer
                module="employees"
                targetId={drawer.id}
                targetType="employee"
                title={t('admin.fullPage.employees_audit_title')}
              />
            )}
          </div>
        ) : null}
      </UnvDrawer>
    </div>
  )
}

export default EmployeesTab
